import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_SELLER_URL } from '../config/settings/environment'

/**
 * Gets the buyer activities data.
 */
export const getBuyerActivities = factoryService(({ dni }) =>
  getJsonRequest(`${REACT_APP_API_BASE_SELLER_URL}/v1/sii/actividad-economica/${dni}`, { retries: 2 })
)

/**
 * Gets the buyer address.
 */
export const getBuyerAddress = factoryService(({ dni }) =>
  getJsonRequest(`${REACT_APP_API_BASE_SELLER_URL}/v1/sii/direcciones/${dni}`)
)

/**
 * Gets the buyer business data.
 */
export const getBuyerBusiness = factoryService(({ dni }) =>
  getJsonRequest(`${REACT_APP_API_BASE_SELLER_URL}/v1/sii/contribuyente/${dni}`, { retries: 2 })
)

/**
 * Get the income bracket for a given 'natural' buyer dni and year.
 */
export const getBuyerIncomeBracket = factoryService(({ dni, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_SELLER_URL}/v1/sii/tramo-renta/${dni}/${year}`)
)

/**
 * Get the sales income for a given 'legal' buyer dni and year.
 */
export const getBuyerIncomeSales = factoryService(({ dni, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_SELLER_URL}/v1/sii/tramo-venta/${dni}/${year}`)
)

/**
 * Gets representatives.
 */
export const getRepresentatives = factoryService(({ dni }) =>
  getJsonRequest(`${REACT_APP_API_BASE_SELLER_URL}/v1/sii/representante/${dni}`, { retries: 2 })
)
